require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-alberto-franchini-forme-dellabitare-collettivo-nel-cantone-ticino-mendrisio-21-ottobre-2019.json") })
        }
      }, "path---relazioni-e-conferenze-alberto-franchini-forme-dellabitare-collettivo-nel-cantone-ticino-mendrisio-21-ottobre-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-alberto-franchini-forme-dellabitare-collettivo-nel-cantone-ticino-mendrisio-21-ottobre-2019!./.cache/json/relazioni-e-conferenze-alberto-franchini-forme-dellabitare-collettivo-nel-cantone-ticino-mendrisio-21-ottobre-2019.json
// module id = 695
// module chunks = 231608221292675